"use client";
import { Button } from "@workspace/ui/components/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@workspace/ui/components/dropdown-menu";
import { EllipsisVertical, LogOut } from "lucide-react";
import { useRouter } from "next/navigation";

interface InterviewGuestMenuProps {
  onPauseSession?: () => void;
  onHelp?: () => void;
  releaseWakeLock?: () => void;
}

export function InterviewGuestMenu({
  onPauseSession,
  onHelp,
  releaseWakeLock,
}: InterviewGuestMenuProps) {
  const router = useRouter();

  const handleLogout = () => {
    // Release wake lock before leaving
    releaseWakeLock?.();

    // Clear the guest token cookie
    document.cookie =
      "casey_guest_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

    // Redirect to home
    router.push("/");
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="relative h-8 w-8 rounded-full">
          <EllipsisVertical className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-56" align="end" forceMount>
        {/* Guest User Info */}
        <DropdownMenuLabel className="font-normal">
          <div className="flex flex-col space-y-1">
            <p className="text-sm font-medium leading-none">Guest User</p>
          </div>
        </DropdownMenuLabel>

        <DropdownMenuSeparator />

        {/* Log out action */}
        <DropdownMenuItem onClick={handleLogout}>
          <LogOut className="mr-2 h-4 w-4" />
          Leave Session
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
